import React from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';

import { useDeliveryContext } from '../../../utils/hooks/useDeliveryContext';
import { useScrollToElement } from '../../../utils/hooks/useScrollToElement';
import { ArticleCard } from '../../ui/cards/Article';
import { Pagination } from '../../ui/pagination/Pagination';

const StyleArticleList = styled.div`
  display: grid;
  grid-row-gap: 2em;
  grid-template-columns: 1fr;
  padding-top: 2em;
  padding-bottom: 4em;
  clear: both;
  @media all and (min-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 2em;
    z-index: 50;
  }
`;

export const ArticleList: React.FC<{ pagination?: boolean }> = ({
  pagination
}) => {
  const listRef = React.useRef<HTMLDivElement>(null);
  const location = useLocation();
  const { scrollTo } = useScrollToElement();
  const [page, setPage] = React.useState(0);
  const { articles, getArticleCountByType, getPaginatedArticles } =
    useDeliveryContext();

  React.useEffect(() => {
    setPage(0);
  }, [location.pathname]);

  return (
    <>
      {pagination ? (
        <>
          <StyleArticleList ref={listRef}>
            {getPaginatedArticles({ page }).map((item) => (
              <ArticleCard
                key={`article_${item?.title}`}
                title={item?.card?.title}
                image={item?.image}
                imageOverlay={item?.imageOverlay}
                description={item?.card?.description}
                buttonLabel={item?.card?.buttonLabel}
                link={item.link}
              />
            ))}
          </StyleArticleList>
          <Pagination
            className="pagination"
            center
            currentPage={page}
            total={getArticleCountByType()}
            itemsPerPage={2}
            pageRangeDisplayed={1}
            pageOnChange={({ selected }) => {
              setPage(selected);
              if (typeof scrollTo === 'function') {
                scrollTo({
                  ref: listRef,
                  distanceTop: 50,
                  behaviour: 'auto'
                });
              }
            }}
          />
        </>
      ) : (
        <StyleArticleList>
          {articles({ excludeFirst: true }).map((item) => (
            <ArticleCard
              key={`article_${item?.title}`}
              title={item?.card?.title}
              image={item?.image}
              imageOverlay={item?.imageOverlay}
              description={item?.card?.description}
              buttonLabel={item?.card?.buttonLabel}
              link={item.link}
            />
          ))}
        </StyleArticleList>
      )}
    </>
  );
};
